import React, { useState } from 'react'
import FileUpload from './component/UploadAudio'
import UploadMagazine from './component/UploadMagazine'
import UploadTexts from './component/UploadTexts'
import MagazineList from './component/MagazineList'
import AudioStats from './component/Statistics'
import GolosnStats from './component/GolosnStats'
import AuthScreen from './component/AuthScreen'
import styled from 'styled-components'

const theme = {
  background: '#f8fafc',
  text: '#0f172a',
  primary: '#4f46e5',
  secondary: '#f1f5f9',
  border: '#e2e8f0',
  error: '#ef4444',
  success: '#22c55e',
  hover: '#e0e7ff',
  shadow: '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  cardBackground: '#ffffff',
  inputBackground: '#ffffff',
  buttonText: '#ffffff',
};

// ─── Icons ────────────────────────────────────────────────────────────────────

function IconUpload() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  );
}

function IconChart() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  );
}

function IconPhone() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2.5"/>
      <line x1="10.5" y1="18.5" x2="13.5" y2="18.5"/>
    </svg>
  );
}

function IconList() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6"/>
      <line x1="8" y1="12" x2="21" y2="12"/>
      <line x1="8" y1="18" x2="21" y2="18"/>
      <line x1="3" y1="6" x2="3.01" y2="6"/>
      <line x1="3" y1="12" x2="3.01" y2="12"/>
      <line x1="3" y1="18" x2="3.01" y2="18"/>
    </svg>
  );
}

function IconChevronLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  );
}

function IconChevronRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  );
}

function IconBook() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  );
}

function IconMenu() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  );
}

// ─── Layout ───────────────────────────────────────────────────────────────────

const SIDEBAR_W = 248;
const SIDEBAR_W_MINI = 64;

const Shell = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: ${p => p.visible ? 1 : 0};
  pointer-events: ${p => p.visible ? 'all' : 'none'};
  transition: opacity 0.25s;

  @media (min-width: 768px) {
    display: none;
  }
`;

const Sidebar = styled.aside`
  width: ${p => p.collapsed ? `${SIDEBAR_W_MINI}px` : `${SIDEBAR_W}px`};
  min-height: 100vh;
  background: #111827;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  overflow: hidden;
  transition: width 0.22s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 767px) {
    width: ${SIDEBAR_W}px;
    transform: ${p => p.mobileOpen ? 'translateX(0)' : `translateX(-${SIDEBAR_W}px)`};
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

const LogoArea = styled.div`
  padding: 1.25rem;
  border-bottom: 1px solid #1f2937;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 68px;
  flex-shrink: 0;
  overflow: hidden;
`;

const LogoMark = styled.div`
  width: 36px;
  height: 36px;
  background: #4f46e5;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 17px;
  font-weight: 800;
  flex-shrink: 0;
  letter-spacing: -1px;
`;

const LogoText = styled.div`
  flex: 1;
  min-width: 0;
  h1 {
    color: #f9fafb;
    font-size: 14px;
    font-weight: 700;
    margin: 0;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  p {
    color: #6b7280;
    font-size: 11px;
    margin: 2px 0 0 0;
  }
`;

const Nav = styled.nav`
  flex: 1;
  padding: 0.75rem 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

const NavGroup = styled.div`
  margin-bottom: 0.25rem;
`;

const NavGroupLabel = styled.div`
  padding: 0.75rem 1.25rem 0.375rem;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #374151;
  white-space: nowrap;
`;

const NavItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: ${p => p.collapsed ? '0.7rem 0' : '0.6rem 1.25rem'};
  justify-content: ${p => p.collapsed ? 'center' : 'flex-start'};
  border: none;
  border-left: 3px solid ${p => p.isActive ? '#4f46e5' : 'transparent'};
  background: ${p => p.isActive ? 'rgba(79,70,229,0.12)' : 'transparent'};
  color: ${p => p.isActive ? '#e0e7ff' : '#9ca3af'};
  font-size: 13.5px;
  font-weight: ${p => p.isActive ? '500' : '400'};
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  transition: background 0.12s, color 0.12s, border-color 0.12s;

  &:hover {
    background: rgba(255,255,255,0.05);
    color: #e5e7eb;
  }

  svg {
    flex-shrink: 0;
    opacity: ${p => p.isActive ? 1 : 0.55};
    transition: opacity 0.12s;
  }
`;

const CollapseRow = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${p => p.collapsed ? 'center' : 'flex-start'};
  gap: 0.5rem;
  padding: 0.625rem ${p => p.collapsed ? '0' : '1.25rem'};
  border: none;
  border-top: 1px solid #1f2937;
  background: transparent;
  color: #4b5563;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: #9ca3af;
    background: rgba(255,255,255,0.03);
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SidebarFooter = styled.div`
  padding: ${p => p.collapsed ? '0.75rem 0' : '1rem 1.25rem'};
  border-top: 1px solid #1f2937;
  display: flex;
  flex-direction: column;
  align-items: ${p => p.collapsed ? 'center' : 'stretch'};
  gap: 0.625rem;
  overflow: hidden;
  flex-shrink: 0;
`;

const FooterUser = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const LogoutBtn = styled.button`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #374151;
  border-radius: 8px;
  background: transparent;
  color: #9ca3af;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
  transition: all 0.15s;

  &:hover {
    background: rgba(239,68,68,0.1);
    border-color: #ef4444;
    color: #f87171;
  }
`;

const LogoutIconBtn = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #374151;
  border-radius: 8px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;

  &:hover {
    background: rgba(239,68,68,0.1);
    border-color: #ef4444;
    color: #f87171;
  }
`;

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  background: #4f46e5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
`;

const UserInfo = styled.div`
  flex: 1;
  min-width: 0;
  p {
    margin: 0;
    color: #f3f4f6;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    color: #6b7280;
    font-size: 11px;
  }
`;

const MainArea = styled.main`
  flex: 1;
  margin-left: ${p => p.collapsed ? `${SIDEBAR_W_MINI}px` : `${SIDEBAR_W}px`};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.22s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 767px) {
    margin-left: 0;
  }
`;

const TopBar = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 2rem;
  height: 56px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 5;

  @media (max-width: 767px) {
    padding: 0 1rem;
  }
`;

const HamburgerBtn = styled.button`
  display: none;
  flex-shrink: 0;

  @media (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #475569;
    padding: 6px;
    border-radius: 6px;

    &:hover {
      background: #f1f5f9;
      color: #0f172a;
    }
  }
`;

const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 13px;
  color: #94a3b8;
  min-width: 0;

  span.sep { color: #cbd5e1; flex-shrink: 0; }
  span.active { color: #334155; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  @media (max-width: 479px) {
    .bc-home, .bc-group, .bc-sep-first, .bc-sep-second { display: none; }
  }
`;

const PageHeader = styled.div`
  padding: 1.75rem 2rem 0;

  @media (max-width: 767px) {
    padding: 1.25rem 1rem 0;
  }
`;

const PageTitle = styled.h1`
  margin: 0 0 0.2rem 0;
  font-size: 1.375rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.015em;

  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
`;

const PageSubtitle = styled.p`
  margin: 0 0 1.5rem 0;
  font-size: 13.5px;
  color: #64748b;
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 0 2rem 2.5rem;

  @media (max-width: 767px) {
    padding: 0 1rem 2rem;
  }
`;

// ─── Navigation config ────────────────────────────────────────────────────────

const NAV = [
  {
    group: 'Аудио',
    items: [
      { key: 'audio-upload', label: 'Загрузка аудио',   icon: <IconUpload />, sub: 'Загрузка аудиофайлов по разделам' },
      { key: 'audio-stats',  label: 'Статистика',        icon: <IconChart />,  sub: 'Статистика прослушивания по разделам' },
    ],
  },
  {
    group: 'Голос Надежды',
    items: [
      { key: 'golosn-stats', label: 'Статистика приложения', icon: <IconPhone />, sub: 'Прослушивания радио, подкастов и Библии в мобильном приложении' },
    ],
  },
  {
    group: 'Журналы',
    items: [
      { key: 'magazines-list',   label: 'Список журналов',   icon: <IconList />,   sub: 'Журналы, загруженные на сервер' },
      { key: 'magazines-upload', label: 'Загрузка журналов', icon: <IconUpload />, sub: 'Загрузка PDF-журналов на сервер' },
    ],
  },
  {
    group: 'Тексты',
    items: [
      { key: 'texts-upload', label: 'Загрузка уроков', icon: <IconBook />, sub: 'Субботняя школа, утренний и вечерний страж, молодёжная школа — с предпросмотром' },
    ],
  },
];

const allItems = NAV.flatMap(g => g.items);

// ─── App ──────────────────────────────────────────────────────────────────────

export default function App() {
  const [activePage, setActivePage] = useState('audio-upload');
  const [password, setPassword] = useState(() => localStorage.getItem('admin_password') || null);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogin = (pwd) => {
    localStorage.setItem('admin_password', pwd);
    setPassword(pwd);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_password');
    setPassword(null);
  };

  const handleNavClick = (key) => {
    setActivePage(key);
    setMobileOpen(false);
  };

  if (!password) return <AuthScreen onLogin={handleLogin} />;

  const current = allItems.find(i => i.key === activePage);
  const currentGroup = NAV.find(g => g.items.some(i => i.key === activePage))?.group;

  return (
    <Shell>
      <Backdrop visible={mobileOpen} onClick={() => setMobileOpen(false)} />

      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen}>
        <LogoArea>
          <LogoMark>НБ</LogoMark>
          {!collapsed && (
            <LogoText>
              <h1>Наедине с Богом</h1>
              <p>Admin Panel</p>
            </LogoText>
          )}
        </LogoArea>

        <Nav>
          {NAV.map(group => (
            <NavGroup key={group.group}>
              {!collapsed && <NavGroupLabel>{group.group}</NavGroupLabel>}
              {group.items.map(item => (
                <NavItem
                  key={item.key}
                  isActive={activePage === item.key}
                  collapsed={collapsed}
                  onClick={() => handleNavClick(item.key)}
                  title={collapsed ? item.label : undefined}
                >
                  {item.icon}
                  {!collapsed && item.label}
                </NavItem>
              ))}
            </NavGroup>
          ))}
        </Nav>

        <CollapseRow
          collapsed={collapsed}
          onClick={() => setCollapsed(c => !c)}
          title={collapsed ? 'Развернуть панель' : 'Свернуть панель'}
        >
          {collapsed ? <IconChevronRight /> : <IconChevronLeft />}
          {!collapsed && <span>Свернуть панель</span>}
        </CollapseRow>

        <SidebarFooter collapsed={collapsed}>
          {collapsed ? (
            <>
              <Avatar title="Администратор">АД</Avatar>
              <LogoutIconBtn onClick={handleLogout} title="Выйти">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
              </LogoutIconBtn>
            </>
          ) : (
            <>
              <FooterUser>
                <Avatar>АД</Avatar>
                <UserInfo>
                  <p>Администратор</p>
                  <span>Супер-админ</span>
                </UserInfo>
              </FooterUser>
              <LogoutBtn onClick={handleLogout}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Выйти
              </LogoutBtn>
            </>
          )}
        </SidebarFooter>
      </Sidebar>

      <MainArea collapsed={collapsed}>
        <TopBar>
          <HamburgerBtn onClick={() => setMobileOpen(o => !o)} aria-label="Открыть меню">
            <IconMenu />
          </HamburgerBtn>
          <Breadcrumb>
            <span className="bc-home">Главная</span>
            <span className="sep bc-sep-first">›</span>
            <span className="bc-group">{currentGroup}</span>
            <span className="sep bc-sep-second">›</span>
            <span className="active">{current?.label}</span>
          </Breadcrumb>
        </TopBar>

        <PageHeader>
          <PageTitle>{current?.label}</PageTitle>
          <PageSubtitle>{current?.sub}</PageSubtitle>
        </PageHeader>

        <ContentArea>
          {activePage === 'audio-upload'     && <FileUpload theme={theme} savedPassword={password} />}
          {activePage === 'audio-stats'      && <AudioStats theme={theme} />}
          {activePage === 'golosn-stats'     && <GolosnStats />}
          {activePage === 'magazines-list'   && <MagazineList theme={theme} />}
          {activePage === 'magazines-upload' && <UploadMagazine theme={theme} savedPassword={password} />}
          {activePage === 'texts-upload'     && <UploadTexts theme={theme} savedPassword={password} />}
        </ContentArea>
      </MainArea>
    </Shell>
  );
}
